import { render, staticRenderFns } from "./UploadAllowances.vue?vue&type=template&id=f80cf74e&scoped=true&"
import script from "./UploadAllowances.vue?vue&type=script&lang=js&"
export * from "./UploadAllowances.vue?vue&type=script&lang=js&"
import style0 from "./UploadAllowances.vue?vue&type=style&index=0&id=f80cf74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80cf74e",
  null
  
)

export default component.exports